import { createFileRoute, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { hasModule, firstAllowedRoute } from "@/lib/auth";
import { Skeleton } from "@/components/feedback/Skeleton";
import { InboundDetail } from "@/features/warehouse/InboundDetail";
import { getInbound, inboundKeys } from "@/features/warehouse/inbound.api";

// BO-Ontvangst (docs/design_handoff_wms_mw8/README.md §5): one receipt, for the office that closes it.
export const Route = createFileRoute("/_shell/warehouse/inbound/$id")({
  beforeLoad: ({ context }) => {
    if (!hasModule(context.session, "wms_inbound") && !hasModule(context.session, "wms_inbound_write")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  component: ReceiptScreen,
});

function ReceiptScreen() {
  const { t } = useTranslation();
  const { id } = Route.useParams();
  const { session } = Route.useRouteContext();
  const canEdit = session.roles.includes("admin") || hasModule(session, "wms_inbound_write");
  const query = useQuery({ queryKey: inboundKeys.detail(id), queryFn: () => getInbound(id), retry: false });

  if (query.isPending) {
    return (
      <div className="wl-page" data-screen-label="Back-office Warehouse Receipt" aria-busy="true">
        <Skeleton width="280px" height="var(--space-7)" />
        <div style={{ marginTop: "var(--space-4)" }}>
          <Skeleton height="320px" />
        </div>
      </div>
    );
  }
  if (query.isError || !query.data) {
    return (
      <div className="wl-page" data-screen-label="Back-office Warehouse Receipt">
        <h1 className="t-h2">{t("inbound.notFound")}</h1>
      </div>
    );
  }
  return (
    <div className="wl-page" data-screen-label="Back-office Warehouse Receipt">
      <InboundDetail receipt={query.data} canEdit={canEdit} userId={session.userId} canOpenDossier={hasModule(session, "dossiers")} />
    </div>
  );
}
